// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"f800be86","787":"deea3256"}[chunkId] + ".chunk.js";
};